import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { wait } from "../utility/wait";

type affectValueType = {
  pleasantness: number;
  arousal: number;
};

// 暫定 画面切り替え悪さをしている可能性があるので、画面サイズは親コンポーネントから受け取る
interface AffectGridProps {
  affectValue: affectValueType | null;
  setAffectValue: React.Dispatch<React.SetStateAction<affectValueType | null>>;
  isAutoPageTurn?: boolean;
  questionnairePage: number;
  switchTab: (next: number) => void;
  widthValue: number;
}

export const AffectGrid: React.FC<AffectGridProps> = ({
  affectValue,
  setAffectValue,
  isAutoPageTurn,
  questionnairePage,
  switchTab,
  widthValue,
}) => {
  // const [selectedPosition, setSelectedPosition] =
  //   useState<affectValueType | null>(null);
  const [gridSize, setGridSize] = useState<number>(0);

  useEffect(() => {
    // 画面サイズに合わせてグリッドサイズを設定
    const updateGridSize = () => {
      // const width = window.innerWidth;
      const width = widthValue;

      if (width > 600) {
        setGridSize(600);
      } else {
        setGridSize(width * 0.8);
      } // 横幅の80%をグリッドサイズに設定
    };

    updateGridSize();
    window.addEventListener("resize", updateGridSize);

    return () => {
      window.removeEventListener("resize", updateGridSize);
    };
  }, []);

  const handleCellClick = async (pleasantness: number, arousal: number) => {
    setAffectValue({ pleasantness, arousal });

    if (isAutoPageTurn) {
      await wait(100);
      switchTab(questionnairePage + 1);
    }
  };

  const renderGrid = () => {
    const grid = [];
    const cellSize = gridSize / 9; // 9×9のマスに分割

    for (let y = 9; y >= 1; y--) {
      const row = [];
      for (let x = 1; x <= 9; x++) {
        const isSelected =
          affectValue?.pleasantness === x && affectValue?.arousal === y;
        row.push(
          <div
            key={`${x},${y}`}
            onClick={() => handleCellClick(x, y)}
            style={{
              width: `${cellSize}px`,
              height: `${cellSize}px`,
              border: "1px solid black",
              backgroundColor: isSelected ? "lightblue" : "white",
              display: "inline-block",
              textAlign: "center",
              lineHeight: `${cellSize}px`,
              cursor: "pointer",
            }}
          ></div>
        );
      }
      grid.push(
        <div key={y} style={{ display: "flex" }}>
          {row}
        </div>
      );
    }
    return grid;
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center", // 左右方向の中央に配置
        width: "100%", // 横幅を100%に設定
      }}
    >
      <Box sx={{ width: "90%", mb: "1rem" }}>
        <Typography variant="caption">
          下の図は、あなたの感情状態を評価するための格子です。
        </Typography>
        <Typography variant="caption">
          あなたの現在の感情を、“快-不快”と“覚醒-眠気”の2軸で評価し、もっとも当てはまるところを1つ選んでください。
        </Typography>
      </Box>
      <div style={{ height: "1rem" }} />
      {/* Top label */}
      <Box sx={{ display: "flex", width: gridSize * 1.1 }}>
        <Typography
          variant="body2"
          sx={{ flex: 1, height: "20px", textAlign: "left" }}
        >
          怒り
        </Typography>
        <div style={{ flex: 1, height: "20px", textAlign: "center" }}>
          活性(覚醒)
        </div>
        <Typography
          variant="body2"
          sx={{ flex: 1, height: "20px", textAlign: "right" }}
        >
          喜び
        </Typography>
      </Box>

      <div style={{ display: "flex", justifyContent: "center" }}>
        {/* Left label */}
        <div
          style={{
            width: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          不快
        </div>
        {/* Grid */}
        <div
          style={{
            width: `${gridSize}px`,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {renderGrid()}
        </div>
        {/* Right label */}
        <div
          style={{
            width: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          快
        </div>
      </div>
      {/* Bottom label */}
      <Box sx={{ display: "flex", width: gridSize * 1.1 }}>
        <Typography
          variant="body2"
          sx={{ flex: 1, height: "20px", textAlign: "left" }}
        >
          退屈
        </Typography>
        <Typography sx={{ flex: 1, height: "20px", textAlign: "center" }}>
          不活性(眠気)
        </Typography>
        <Typography
          variant="body2"
          sx={{ flex: 1, height: "20px", textAlign: "right" }}
        >
          リラックス
        </Typography>
      </Box>
      <Box sx={{ height: "1rem" }} />
      {/* Display selected position */}
      {/* {affectValue && (
        <div style={{ marginTop: "20px" }}>
          pleasant: {affectValue.pleasantness}, arousal: {affectValue.arousal}
        </div>
      )} */}
    </div>
  );
};
